import { render, staticRenderFns } from "./ShopStoreTakeoutProductAdd.vue?vue&type=template&id=ece7f678&scoped=true"
import script from "./ShopStoreTakeoutProductAdd.vue?vue&type=script&lang=js"
export * from "./ShopStoreTakeoutProductAdd.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreTakeoutProductAdd.vue?vue&type=style&index=0&id=ece7f678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece7f678",
  null
  
)

export default component.exports